<template>
  <div class="list row">
    <div class="col-md-12">
      <h4><font-awesome-icon icon="tree" /> My Tree</h4>
    </div>
    <div class="col-md-12 hgap"></div>
    <div class="col-md-12">
      <header>
        <h5>
            <strong>{{currentMember.surname}}, &nbsp; {{currentMember.firstName}} &nbsp; {{currentMember.middleName}}</strong> &nbsp; ({{currentMember.networkMemberId}})
       </h5>
       <table class="gridview">
         <tr>
            <th>My network ID:&nbsp;{{currentMember.networkMemberId}}</th><th>My level: &nbsp; {{currentMember.level}}</th><th>Total no. of my downlines:&nbsp; {{currentMember.downlinesNo}}</th>
         </tr>
       </table>
      </header>
    </div>
    <div class="col-md-12 hgap"></div>
    <div class="col-md-12">
      <h4><font-awesome-icon icon="table" /> Downlines List</h4>
      <table class="gridview">
        <tr>
            <th>S/N</th><th>Network ID</th><th>Surname</th><th>First Name</th><th>Upline</th><th>Level</th><th>Downlines Count</th><th>Layer</th>
        </tr>
        <tr class="table" :class="{ active: index== currentIndex }" v-for="(generation, index) in generations" :key="generation.id" @click="toggleClass(this,'selected')">
            <td>{{ index+1 }}</td><td>{{ generation.id }}</td><td>{{ generation.surname }}</td><td>{{ generation.firstName }}</td>
            <td>{{ generation.parentId }}</td><td>{{ generation.level }}</td><td>{{ generation.descendantCount }}</td><td>{{ generation.height }}</td>
        </tr>
      </table>
      <div class="col-md-12 hgap"></div>
      <div v-if="loading" class="justify-content-center">
        <font-awesome-icon icon="spinner" /> <span>Loading...please wait</span>
      </div>
      <table class="table table-borderless">
        <tr>
          <td>
            <div class="d-flex justify-content-center">
              Items per Page:
              <select v-model="pageSize" @change="handlePageSizeChange($event)">
                <option v-for="size in pageSizes" :key="size" :value="size">
                  {{ size }}
                </option>
              </select>
            </div>
          </td>
          <td>
            <div class="d-flex justify-content-end">
              <b-pagination v-model="page" :total-rows="count" :per-page="pageSize" prev-text="Prev" next-text="Next" @change="handlePageChange"></b-pagination>
            </div>
          </td>
        </tr>
      </table>
      
    </div>  

  </div>
</template>

<script>
import MemberService from "../services/member.service";

export default {
  name: "descendants-list",
  data() {
    return {
      currentMember: null,
      currentMemberId: 0,
      downlinesNo: 0,
      descendants: [],
      generations: [],
      currentIndex: 0,
      page: 1,
      count: 0,
      pageSize: 25,
      pageSizes: [25, 50, 75, 100],
      totalPages: 0,
      loading: false
    };
  },
  computed: {
    currentUser() {
      return this.$store.state.auth.user;
    } 
  },
  methods: {
    getSponsorDownlinesNo(id) {
      MemberService.getSponsorDownlinesNo(id)
        .then(response => {
          this.currentMember = response.data;
          this.count = this.currentMember.downlinesNo;
          //console.log(response.data);
        })
        .catch(e => {
          console.log(e);
        });
    },

    getDescendants(id) {
      this.loading = true;
      if (this.page) {
        this.page = this.page - 1;
      }
      MemberService.getDescendantsPageable(id, this.page, this.pageSize)
        .then(response => {
          this.descendants = response.data;
          for(let descendant of this.descendants) {
             MemberService.getDownlinesNo(descendant.descendant)
                .then(response => {
                  this.downlinesNo = response.data;
                  this.generations.push({ id: descendant.descendant, surname: descendant.surname, firstName: descendant.first_name, parentId: descendant.parent,
                   level: descendant.level, descendantCount: this.downlinesNo, height: descendant.depth });
                })
                .catch(e => {
                  console.log(e);
                });
          }
          this.loading = false;
        })
        .catch(e => {
          console.log(e);
        });
        
    },

    handlePageChange(value) {
      this.page = value;
      this.generations = [];
      this.getDescendants(this.currentMemberId);
    },

    handlePageSizeChange(event) {
      this.pageSize = event.target.value;
      this.page = 1;
      this.generations = [];
      this.getDescendants(this.currentMemberId);
    },

    toggleClass(el, className) {
      if (el.className.indexOf(className) >= 0) {
         el.className = el.className.replace(className,"");
      }
      else {
        el.className  += className;
      }
    }

  },
  mounted() {
    this.currentMemberId = this.currentUser.username;
    this.getSponsorDownlinesNo(this.currentUser.username);
    this.getDescendants(this.currentUser.username);
  }
};
</script>

<style>
.list {
  text-align: left;
  max-width: 100%;
  margin: auto;
  margin-top: 3.2em;
}
.paginate{
  margin-top: 1.7em;
}
.hgap{
  clear: both;
  margin-top: 1.1em;
}

.gridview
{
    border-collapse: collapse;
    margin: 0px 10px 10px 0;
    /*box-shadow: 3px 3px 4px #bbb;*/
    width: 100%;
    max-width: 100%;    
}

.gridview, .gridview td,  .gridview th
{
    border:  1px solid #cccccc;
}

.gridview th
{
    text-align: left;
    /*font-size: 1.2em;*/
    font-weight: normal;
    color: #F9F9F9;    
    background: #232324;
}

.gridview th a, .gridview th a:link, .gridview th a:visited, .gridview th a:active
{
    color: #fff;
    text-decoration: none;
}

.gridview th a:hover
{
    text-decoration: underline;
}

.gridview tr
{
    background: #fff;
}

.gridview tr:nth-child(odd) 
{
    background-color: #fff;
}
.gridview tr:nth-child(even) 
{
    background-color: #fff;
}

.gridview td 
{
    font-weight: normal;    
    text-align: left;
    vertical-align: top;
}

.gridview td, table th
{
    padding: 5px 8px;
}

.gridview tfoot td
{
    background-color: #fff;
}

.gridview tfoot td .page
{
    color: #000000;
    font-weight: bold;
}

.gridview tr.subfoot, .gridview tr.subfoot td
{
    background-color: #1E90FF;
}

.gridview tr:hover td, .gridview tbody tr:hover td
{
    background-color: #1E90FF;
    color: #fff;
}

.gridview .selected, .gridview tr td .selected
{
    background-color: #1E90FF;
    color: #fff;
}
.alignright{
  float: right;
}
</style>